__turbopack_context__.v({
  "goldenView": "styles-module-scss-module__U0F-cW__goldenView",
  "logoutView": "styles-module-scss-module__U0F-cW__logoutView",
});
